import { render } from "./Packing.vue?vue&type=template&id=05a8e643"
import script from "./Packing.vue?vue&type=script&lang=js"
export * from "./Packing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__